///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//

const { default: axios } = require("axios");

///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.dashboard = abcsetup.dashboard || {};
abcsetup.dashboard.fs_cm = abcsetup.dashboard.fs_cm || {};
abcsetup.dashboard.fs_cm.frontstore = abcsetup.dashboard.fs_cm.frontstore || {};

///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.dashboard.fs_cm = {
    init: function ()
    {
        this.initListeners();
    },

    initListeners: function()
    {
        $(document).on('click', '.btn-rfp-delete', function ()
        {
            const id = $(this).data('id');

            abcsetup.alerts.prompt('Reject Consumer RFP', 'Reason for deletion:', function([clickedOk, inputText]) {

                if (clickedOk) {
                    abcsetup.blockUI(true);

                    axios.delete('/consumer_rfp/' + id, {data: {reason: inputText}}).then(response => {
                        window.location.reload()
                    });
                }

            }, false, false, {textarea: true})
        });

        // New item in process - delete button clicked
        $(document).on('click', '#new_items_process .btn-delete', function ()
        {
            var _this = $(this);

            abcsetup.alerts.confirm('Delete Item', 'Are you sure you want to delete this item?', function (resp)
            {
                if (resp)
                {
                    abcsetup.dashboard.fs_cm.frontstore.delete(_this.data('id'));
                }
            });
        });

        // New item in process - delete button clicked
        $(document).on('click', '#new_rx_items .btn-delete', function ()
        {
            var _this = $(this);

            abcsetup.alerts.confirm('Delete Item', 'Are you sure you want to delete this item?', function (resp)
            {
                if (resp)
                {
                    abcsetup.dashboard.fs_cm.rx.delete(_this.data('id'));
                }
            });
        });

        // Cancel Maintenance button clicked
        $(document).on('click', '#item_maintenance_in_process .btn-cancel', function () {
            var _this = $(this);

            abcsetup.alerts.confirm('Cancel Maintenance', 'Are you sure you want to cancel maintenance on this item?', function (resp) {
                if (resp) {
                    abcsetup.dashboard.fs_cm.item_maintenance.cancel(_this.data('id'),_this.data('type'));
                }
            });
        });

        this.ncm.init();
        this.promo.init();

    },

    ///////////////////////////////////////////////////////////////////////////////////////////////////
    //
    //  Frontstore Methods
    //
    ///////////////////////////////////////////////////////////////////////////////////////////////////
    frontstore: {
        /**
         *
         */
        delete: function (id)
        {
            abcsetup.dashboard.showLoading($('#new_items_panel'));
            $('#new_items_panel').find('.dataTables_wrapper').hide();

            axios.delete('/front_store/' + id).then(response => {
                window.location.reload();
            });
        },
    },

    item_maintenance: {
        /**
         *
         * @param id
         */
        cancel: function (id)
        {
            abcsetup.dashboard.showLoading($('#new_items_panel'));
            $('#new_items_panel').find('.dataTables_wrapper').hide();

            axios.get('/front_store/maintenance/' + id + '/cancel').then(response => {
                window.location.reload();
            });
        }
    },

    ///////////////////////////////////////////////////////////////////////////////////////////////////
    //
    //  Promo Methods
    //
    ///////////////////////////////////////////////////////////////////////////////////////////////////
    promo:{
        init: function(){
            const promoToggle = $('.bhoechie-tab-content:has(#promo_workflow_tables) .btn-group-toggle');
            promoToggle.on('click', event => {
                $(`.bhoechie-tab-content:has(#promo_workflow_tables) .promo_workflow_table`).hide();
                $(`.bhoechie-tab-content:has(#promo_workflow_tables) .${event.target.value}_table`).show();
            });

            let recordsTotal = 0;
            $('#promo_workflow_tables .promo_workflow_table:not(".history_table") .datatable').on('xhr.dt', (event, settings, json) => {
                setTimeout(function() {
                    $('#promo_workflow_promo_badge').text($('#app_data_tables_promo_outstanding_data_table').data('total-records'));
                    $('#promo_workflow_promo_plan_badge').text($('#app_data_tables_promo_promo_plan_c_m_workflow_task_data_table').data('total-records'));
                }, 250);

                recordsTotal += (json.recordsTotal ?? 0);
                abcsetup.dashboard.setBadge($('#promo_outstanding_table_badge'), recordsTotal);
            });
        }
    },


    ///////////////////////////////////////////////////////////////////////////////////////////////////
    //
    //  Large Customer Opportunity Methods
    //
    ///////////////////////////////////////////////////////////////////////////////////////////////////
    ncm:{
        init: function(){
            const ncmToggle = $('.bhoechie-tab-content:has(#ncm_tables) .btn-group-toggle');
            ncmToggle.on('click', event => {
                $(`.bhoechie-tab-content:has(#ncm_tables) .ncm_table`).hide();
                $(`.bhoechie-tab-content:has(#ncm_tables) .${event.target.value}_table`).show();
            });

            let recordsTotal = 0;
            $('#ncm_tables .ncm_table:not(".history_table") .datatable').on('xhr.dt', (event, settings, json) => {
                setTimeout(function() {
                    $('#ncm_matching_badge').text($('#app_data_tables_new_customer_matching_events_data_table').data('total-records'));
                    $('#ncm_bids_badge').text($('#app_data_tables_new_customer_matching_outstanding_data_table').data('total-records'));
                }, 250);

                recordsTotal += (json.recordsTotal ?? 0);
                abcsetup.dashboard.setBadge($('#ncm_tables_badge'), recordsTotal);
            });
        }
    },

   ///////////////////////////////////////////////////////////////////////////////////////////////////
    //
    //  RFP Methods
    //
    ///////////////////////////////////////////////////////////////////////////////////////////////////
    rfp: {
        init() {
            // TODO Working around the responsive plug-in not working right now.
            $('#rfp_outstanding,#rfp_in_review,#rfp_unsolicited_in_review,#rfp_library').find('.datatable').css('min-width', '100%');

            const inReviewToggle = $('.bhoechie-tab-content:has(#rfp_in_review) .btn-group-toggle');
            inReviewToggle.on('click', event => {
                $(`.bhoechie-tab-content:has(#rfp_in_review) .in_review_table`).hide();
                $(`.bhoechie-tab-content:has(#rfp_in_review) .${event.target.value}_table`).show();
            });

            $('#rfp_in_review .pending_review_table .datatable').on('xhr.dt', (event, settings, json) => {
                const badge = inReviewToggle.find('label:has(input[value=pending_review]) .badge');

                if (json.recordsTotal > 0) {
                    badge.show().text(json.recordsTotal);
                } else {
                    badge.hide();
                }
            });

            $('#rfp_in_review .pending_other_user_review_table .datatable').on('xhr.dt', (event, settings, json) => {
                const badge = inReviewToggle.find('label:has(input[value=pending_other_user_review]) .badge');

                if (json.recordsTotal > 0) {
                    badge.show().text(json.recordsTotal);
                } else {
                    badge.hide();
                }
            });

            $('#rfp_in_review .pending_supplier_responses_table .datatable').on('xhr.dt', (event, settings, json) => {
                const badge = inReviewToggle.find('label:has(input[value=pending_supplier_responses]) .badge');

                if (json.recordsTotal > 0) {
                    badge.show().text(json.recordsTotal);
                } else {
                    badge.hide();
                }
            });

            $('#rfp_in_review .pending_submissions_table .datatable').on('xhr.dt', (event, settings, json) => {
                const badge = inReviewToggle.find('label:has(input[value=pending_submissions]) .badge');

                if (json.recordsTotal > 0) {
                    badge.show().text(json.recordsTotal);
                } else {
                    badge.hide();
                }
            });

            $('#rfp_unsolicited_in_review_badge .datatable').on('xhr.dt', (event, settings, json) => {
                abcsetup.dashboard.setBadge($('#rfp_unsolicited_in_review_badge'), json.recordsTotal);
            });

            window.setTimeout(() => this._syncInReviewSubToggle(inReviewToggle), 1250);
        },

        /**
         * That little button toggle issue bugs me. That is, if they previously selected one other than the first, it'll highlight what they selected previously and also the first toggle button.
         * This syncs the button toggle with what's actually being displayed.
         * A bit hacky, but it works.
         *
         * @param inReviewToggle
         * @private
         */
        _syncInReviewSubToggle(inReviewToggle) {
            window.setTimeout(() => {
                const visibleReviewTableClass = String(
                    Array.from(
                        $('#rfp_in_review .in_review_table:not(.hide)').get(0).classList
                    ).filter(className => className !== 'in_review_table' && className.endsWith('_table')) [0]
                );
                const toggleInputValue = visibleReviewTableClass.substring(0, visibleReviewTableClass.lastIndexOf('_table'));

                inReviewToggle.find('.btn').removeClass('active');
                inReviewToggle.find(`input[value=${toggleInputValue}]`).closest('.btn').addClass('active');
            }, 2000);
        },
    }
}
